"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CascadingGridItem = void 0;
var react_1 = __importDefault(require("react"));
var List_1 = require("../List");
var CascadingGridItem = function (_a) {
    var className = _a.className, _b = _a.style, style = _b === void 0 ? {} : _b, children = _a.children, rest = __rest(_a, ["className", "style", "children"]);
    return (react_1["default"].createElement(List_1.List.Item, __assign({ className: ['cascading-grid-item', className], style: __assign(__assign({}, style), { visibility: 'hidden' }) }, rest), children));
};
exports.CascadingGridItem = CascadingGridItem;
//# sourceMappingURL=CascadingGridItem.js.map